import functions from '../functions';
import { list } from './list';
import Slider from "../components/Slider";

$(() => {
    listPackage.init();
});

const listPackage = {
    $form: null,
    form: null,
    $filter: null,
    filter: null,
    defaults: {
        _page: 1,
        perPage: 10,
        language: functions.getLang(),
        objectGroupId: 1,
        dates: null,
        dateFrom: null,
        dateTo: null,
        destination: null,
        dynamicPackage: 1,
        hasArrival: null,
        arrivalDateFrom: null,
        arrivalDateTo: null,
        guests: '2,0,0',
    },
    params: {},
    isHome: false,
    $listItems: null,
    filterParams: {
        pool: '',
        parking: '',
        pets: '',
        internet: '',
        objectTypeId: '',
        objectName: '',
        unitServiceIds: '',
        serviceId: '',
        categoryObject: null,
        distanceBeach: null,
        distanceCenter: null
    },
    mainFields: ['dateFrom', 'dateTo', 'destination', 'guests', '_page'],
    init() {
        this.$form = $('.search-form.search-package');
        this.form = this.$form[0];

        if( ! this.form) {
            return;
        }

        this.$filter = $('.search-filter');
        this.filter = this.$filter[0];

        this.$filters = $('.search-filters');
        this.$listItems = $('.list-items');

        if (this.$form.attr('data-countryId')) {
            this.defaults.destination = this.$form.attr('data-countryId');
        }

        this.isHome = this.$form.attr('data-ishome');
        this.defaults.dynamicPackage = this.$form.attr('data-dynamicPackage');

        this.getParams();
        functions.setFormData(this.form, this.params);

        if($('[name=guests]').val()) {
            this.params.guests = $('[name=guests]').val();
        }

        this.find(this.params);

        this.$form.on('submit', e => {
            const $target = $(e.target);
            e.preventDefault();

            let params = functions.getFormData($target);
            params._page = 1;

            if(this.isHome) {
                params = functions.cleanParams(params);
                location = $(e.target).find('[data-listurl]').attr('data-listurl') + '#' + $.param(params);
            } else {
                functions.setUrlData(params, true, true);
            }
        });

        if (this.$filters[0]) {

            functions.setFormData(this.$filters[0], this.params);

            this.$filters.find('input').on('change', e => {
                let params = functions.getFormData(this.$form);
                let filterParams = functions.getFormData(this.$filters);
                params = $.extend({}, params, filterParams);

                functions.setUrlData(params, true, true);
            });

            this.$filters.on('submit', e => {
                const $target = $(e.target);
                e.preventDefault();

                let params = functions.getFormData($target);
                let filterParams = functions.getFormData(this.$filters);
                params = $.extend({}, params, filterParams);

                functions.setUrlData(params, true, true);
            });
        }

        $('.ms-clear').on('click', e => {
            e.preventDefault();
            e.stopPropagation();

            this.params.destination = '';
            $(this.form.destination).val('').trigger('change');
        });

        $('.btn-clear-filters').on('click', e => {
            e.preventDefault();

            this.params = $.extend({}, functions.getFormData(this.$form), this.filterParams);
            this.params._page = this.defaults._page;

            functions.setUrlData(this.params, true);
            functions.setFormData(this.form, this.params);
        });

        $(window).on('hashchange', e => {
            this.getParams();

            functions.scrollToElement(this.$listItems, 100);
            this.find(this.params);
        });

        $('#filterModal').on('click', 'input[type="radio"]', e => {
            if ( this.radioValues[e.target.name] == e.target.value ) {
                this.radioValues[e.target.name] = null;
                e.target.checked = false;
                this.$form.trigger('change');
                return;
            }
            this.radioValues[e.target.name] = e.target.value;
        });

    },
    getParams() {
        this.params = list.getParams(this.params, this.filterParams, this.defaults);

        if (this.params.guests) {
            this.params.guests = this.params.guests.startsWith('0') ? null : this.params.guests;
        }

        this.params.arrivalDateFrom = this.params.dateFrom ? this.params.dateFrom : null;
        this.params.arrivalDateTo = this.params.dateTo ? this.params.dateTo : null;
        this.params.hasArrival = this.params.arrivalDateFrom ? 3 : null;
    },
    splitCalendarDates(dates) {
        if(dates || dates == '') {
            const aDates = dates.split(' - ');
            this.params.dateFrom = aDates[0] ? aDates[0] : null;
            this.params.dateTo = aDates[1] ? aDates[1] : null;
        }
    },
    find(params) {
        if(! this.params.dates) {
            this.params.dateTo = $('input[name="dateTo"]').val();
        }

        if (params['dateFrom']) {
            params['arrivalDateFrom'] = params['dateFrom'];
            params['hasArrival'] = 3;
        }

        list.find(params).then((response) => {
            list.findDone(response);
            // LOZAD
            window.observer.observe();

            let listSlider = [];

            $('[id^=card-slider]').each((index, element) => {
                listSlider[index] = new Slider('#' + $(element).attr('id'), {
                    rubberband: false,
                    loop: true,
                    arrows: true,
                    slides: {
                        perView: 1,
                        spacing: 0,
                    },
                });
            });

            /*$('.departure').on('click', e => {
                e.preventDefault();

                const $target = $(e.currentTarget);
                let href = $target.attr('data-href');
                href = href.split('#')[0];

                const dateFrom = $target.attr('data-datefrom');
                const dateTo = $target.attr('data-dateto');

                href += '#dateFrom=' + dateFrom + '&dateTo=' + dateTo;
                //location = href; 
                window.open(href, '_blank');
            });*/

        });
    }
};